export const ignored_words = [
    'the', 'to', 'a', 'and', 'in', 'of', 'are', 'or', 'is', 'for', 'be', 'on', 'was',
    'with', 'by', 'as', 'at', 'it', 'has', 'an', 'has', 'its', 'from', 'but', 'have',
    'that', 'can', 'also', 'this', 'were', 'had', 'which', 'would', 'after', 'year',
    "'s",
];
